import { combineReducers } from 'redux'
import { omit } from 'lodash'
import {
  UI_TOPBAR_EXPAND,
  UI_TOPBAR_COLLAPSE,
  UI_DRAWER_EXPAND,
  UI_DRAWER_COLLAPSE,
  MOBILE_SEARCH_TOGGLE,
  MOBILE_SEARCH_ON,
  MOBILE_SEARCH_OFF,
  UI_CONFIGURE_TOP_BAR,
  UI_CLEAR_CONFIGURE_TOP_BAR,
} from '../../actions'

const topBarExpanded = (prevState = true, action) => {
  switch (action.type) {
    case UI_TOPBAR_EXPAND:
      return true
    case UI_TOPBAR_COLLAPSE:
      return false
    default:
      return prevState
  }
}

const drawer = (prevState = false, action) => {
  switch (action.type) {
    case UI_DRAWER_EXPAND:
      return true
    case UI_DRAWER_COLLAPSE:
      return false
    default:
      return prevState
  }
}

const mobileSearch = (prevState = false, { type }) => {
  switch (type) {
    case MOBILE_SEARCH_ON:
      return true
    case MOBILE_SEARCH_OFF:
      return false
    case MOBILE_SEARCH_TOGGLE:
      return !prevState
    default:
      return prevState
  }
}

export const defaultTopBarConfigState = {
  title: null,
  expandable: false,
  toolbar: null,
  hasFilters: false,
  openFilters: false,
  topSearch: false,
  titleDropdownWorlds: false,
  filtersLines: 1,
  match: { params: {} },
}

const topBarConfig = (
  prevState = { 0: defaultTopBarConfigState },
  { type, payload }
) => {
  switch (type) {
    case UI_CONFIGURE_TOP_BAR: {
      const { inner = 0, ...config } = payload
      return {
        ...prevState,
        [inner]: { ...prevState[inner], ...config },
      }
    }
    case UI_CLEAR_CONFIGURE_TOP_BAR: {
      const { inner = 0 } = payload
      return omit(prevState, inner)
    }
    default:
      return prevState
  }
}

export default combineReducers({
  topBarExpanded,
  drawer,
  mobileSearch,
  topBarConfig,
})



// WEBPACK FOOTER //
// ./src/reducers/ui/index.js